/**
 * 全局API地址
 */

const API = {
  send_code_post: '/login/msgCodeLoginSendCode',
  login_code_post: '/login/msgCodeLogin',
  set_organization_post: '/login/setOrganization',
  product_list_post: '/product/listByExampleForBack',
  product_page_post: '/product/pageByExampleForBack',
  group_page_list_post: '/dashboardGroup/pageByExample',
  add_group_post: '/dashboardGroup/add',
  check_group_name_post: '/dashboardGroup/checkGroupName',
  organization_list_post: '/staff/queryAllOrgList',
  group_page_edit_post: '/dashboardGroup/edit',
  group_delete_post: '/dashboardGroup/delete',
  dashboard_page_list_post: '/dashboard/pageByExampleForBack',
  dashboard_page_edit_post: '/dashboard/edit',
  dashboard_img_default_post: '/dashboard/getDashBoardImageDefaults',
  dashboard_detail_post: '/dashboard/detail',
  dashboard_edit_sortNo_and_enable_post: '/dashboard//editSortNoAndEnable',
  product_add_post: '/product/add',
  product_edit_post: '/product/edit',
  product_delete_post: '/product/delete',
  product_isEnable_post: '/product/isEnable',
  check_by_groupId_post: 'dashboard/checkByGroupId',
  product_list_get: '/product/listProductLine',
  app_list_get: '/product/listAppByProductLine',
  application_list_get: '/product/listAppInstByApplication',
  login_out_post: '/login/logout',
  refresh_token_post: '/login/refreshToken',
  dashboard_group_page_post: '/dashboardGroup/pageByExample',
  product_group_list_post: '/dashboardGroup/listByExample',
  resource_list_post: '/product/listResourceByAppInst',
  pic_upload_post: '/upload/one',
  dashboard_add_post: '/dashboard/add',
  dashboard_edit_post: '/dashboard/edit',
  dashboard_page_post: '/dashboard/pageByExampleForBack',
  dashboard_del_post: '/dashboard/delete',
  dashboard_isEnable_post: '/dashboard/isEnable',
  login_log_post: '/businessLog/pageLoginByExample',
  log_page_post: '/businessLog/pageNormalByExample',
  organization_tree_post: '/staff/organizationTree',
};

export default API;
